import { SVGProps } from "react"

export const ImageIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M6.00001 7.16667C4.98667 7.16667 4.16667 6.34667 4.16667 5.33333C4.16667 4.32 4.98667 3.5 6.00001 3.5C7.01334 3.5 7.83334 4.32 7.83334 5.33333C7.83334 6.34667 7.01334 7.16667 6.00001 7.16667ZM6.00001 4.5C5.54001 4.5 5.16667 4.87333 5.16667 5.33333C5.16667 5.79333 5.54001 6.16667 6.00001 6.16667C6.46001 6.16667 6.83334 5.79333 6.83334 5.33333C6.83334 4.87333 6.46001 4.5 6.00001 4.5Z"
			fill="#1F6334"
		/>
		<path
			d="M9.99999 15.1668H5.99999C2.37999 15.1668 0.833328 13.6202 0.833328 10.0002V6.00016C0.833328 2.38016 2.37999 0.833496 5.99999 0.833496H7.99999C8.27333 0.833496 8.49999 1.06016 8.49999 1.3335C8.49999 1.60683 8.27333 1.8335 7.99999 1.8335H5.99999C2.92666 1.8335 1.83333 2.92683 1.83333 6.00016V10.0002C1.83333 13.0735 2.92666 14.1668 5.99999 14.1668H9.99999C13.0733 14.1668 14.1667 13.0735 14.1667 10.0002V7.3335C14.1667 7.06016 14.3933 6.8335 14.6667 6.8335C14.94 6.8335 15.1667 7.06016 15.1667 7.3335V10.0002C15.1667 13.6202 13.62 15.1668 9.99999 15.1668Z"
			fill="#1F6334"
		/>
		<path
			d="M12.1333 4.93319C13.3115 4.93319 14.2667 3.97805 14.2667 2.79985C14.2667 1.62164 13.3115 0.666504 12.1333 0.666504C10.9551 0.666504 10 1.62164 10 2.79985C10 3.97805 10.9551 4.93319 12.1333 4.93319Z"
			stroke="#1F6334"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M14.6667 5.33317L14 4.6665"
			stroke="#1F6334"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M1.78001 13.1335C1.62001 13.1335 1.46001 13.0535 1.36667 12.9135C1.21334 12.6869 1.27334 12.3735 1.50667 12.2202L4.79334 10.0135C5.51334 9.52687 6.50667 9.58687 7.16001 10.1402L7.38001 10.3335C7.71334 10.6202 8.28001 10.6202 8.60667 10.3335L11.38 7.95354C12.0867 7.34687 13.2 7.34687 13.9133 7.95354L15 8.88687C15.2067 9.06687 15.2333 9.3802 15.0533 9.59354C14.8733 9.8002 14.56 9.82687 14.3467 9.64687L13.26 8.71353C12.9267 8.42687 12.36 8.42687 12.0267 8.71353L9.25334 11.0935C8.54667 11.7002 7.43334 11.7002 6.72001 11.0935L6.50001 10.9002C6.19334 10.6402 5.68667 10.6135 5.34667 10.8469L2.06001 13.0535C1.97334 13.1069 1.87334 13.1335 1.78001 13.1335Z"
			fill="#1F6334"
		/>
	</svg>
)
